/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


export { AnalyticsPlugin, AnalyticsPlugin as ApplicationInsights } from "./JavaScriptSDK/AnalyticsPlugin";
//# sourceMappingURL=applicationinsights-analytics-js.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-analytics-js/dist-esm/applicationinsights-analytics-js.js
// module id = 105
// module chunks = 0